import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalstorageService } from './localstorage.service';

@Injectable()
export class LoginauthService implements CanActivate {
  constructor(private router: Router, private localStorageService: LocalstorageService) {}
  canActivate(): boolean {
    const userDetails = this.localStorageService.getData("currentUserToken");
    const currentUser = this.localStorageService.getData("currentUser");
    if (userDetails) {
      if(!userDetails.data.is_steps_completed && currentUser.role_id == '3') {
        this.router.navigate(['/get-started-deposits']);
      } else {
        // User is logged in, redirect to dashboard
        this.router.navigate(['/dashboard']);
        return false;
      }
    }
    // User is not logged in, allow access to the login page
    return true;
  }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/loginauth.service.ts